import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getLocalStorage, getUser } from '../utils/func';
import config from '../utils/config';
import { eligibleEntry, isPlainHome, skipVisit } from './state';

const Context = createContext({ ready: true, eligible: false, dismiss: () => {}, launchResolved: () => {} });
export const useOnboarding = () => useContext(Context);

export default function OnboardingProvider({ children }) {
  const location = useLocation();
  const [ready, setReady] = useState(() => !(window.Capacitor?.isNativePlatform?.() === true
    || window.location.protocol === 'capacitor:'));
  const [eligible, setEligible] = useState(() => eligibleEntry(location, document.referrer,
    Boolean(getUser()?.id || getLocalStorage(config.token))));
  const dismiss = useCallback(() => { skipVisit(); setEligible(false); }, []);
  const launchResolved = useCallback((unknown = false) => {
    if (unknown) dismiss();
    setReady(true);
  }, [dismiss]);
  useEffect(() => { if (!eligible) skipVisit(); }, [eligible]);
  useEffect(() => {
    if (!isPlainHome(location) || location.state?.feedRefresh) dismiss();
  }, [location, dismiss]);
  const value = useMemo(() => ({ ready, eligible, dismiss, launchResolved }), [ready, eligible, dismiss, launchResolved]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
